import { gql } from 'graphql-request'
import { formalizationAPI } from '../api'

const CUSTOMER_TRIAGE_QUERY = gql`
  query CustomerTriage($statusFlow: String, $profile: ProfileType) {
    customerTriage(statusFlow: $statusFlow, profile: $profile) {
      applicationID
      customerName
      customerTaxDocument
      consultantName
      folderCompletedAt
      status
    }
  }
`

type DTO = {
  customerTriage: Triage[]
}

export async function getCustomersInTriage(
  statusFlow?: string,
  profile?: string,
): Promise<DTO['customerTriage']> {
  const response = await formalizationAPI.request<DTO>(CUSTOMER_TRIAGE_QUERY, {
    statusFlow,
    profile,
  })

  return response.customerTriage
}
